export default [
  {
    path: "referrals",
    name: "referrals",
    component: (): Promise<any> => import(/* webpackChunkName: "webmaster:referrals" */ "@/views/Webmaster/ReferralsView.vue")
  }
];
